import { forwardRef } from "react";
import styles from "./Button.module.css";

/**
 * variant: primary | secondary | danger | ghost
 * size: md (48px, default/glove-friendly) | sm (compact, for dense admin-y UI)
 *
 * Primary is the DEFAULT, which is worth knowing when reading a page:
 * `<Button>` with no variant is the main action, so extra primaries are
 * easy to add without typing anything. docs/UI_ACTIONS.md rule 1 is about
 * exactly that -- 24 pages had more than one.
 *
 * forwardRef so a caller can focus it. ActionMenu needs this: without a
 * ref, Escape could close the menu but not return focus to the trigger,
 * and a keyboard user would be dropped at the top of the document with
 * no indication of where they had been. A ref that silently does nothing
 * is worse than no ref, because the behaviour looks implemented.
 */
export const Button = forwardRef(function Button(
  { variant = "primary", size = "md", as: As = "button", className = "", ...props },
  ref,
) {
  const classes = [styles.button, styles[variant], styles[size], className].filter(Boolean).join(" ");
  return <As ref={ref} className={classes} {...props} />;
});
